
// Zacatek kontroly vyher
import {
    madnes_get_alpha,
    madnes_get_dimension_he,
    madnes_get_dimension_wi,
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_get_texture,
    madnes_get_visible,
    madnes_set_alpha,
    madnes_set_img_center,
    madnes_set_pos_x,
    madnes_set_pos_y,
    madnes_set_texture,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    server_config,
    picture_convert,
    server_result,
    freespins,
    set_inanim,
    inmoneyadd,
    inbigwin,
    set_inwincount, in_free_spins, states, set_in_free_spins, set_rotated, set_round_running, set_server_result
} from "../framework/src/engine/madnes/madnes_variables";

import {
    madnes_add_win, madnes_end_freespins, madnes_end_round, madnes_set_win,
    madnes_start_freespins,
    madnes_win_anim_reset,
    madnes_win_anim_skip
} from "../framework/src/engine/madnes/madnes";
import {madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete, madnes_anim_play,
    madnes_generate_frame_names
} from "../framework/src/engine/madnes/madnes_anims";
import {hide_all_27, show_all_27} from "./turbo27_reels";
import {ctrl_end_round_freespins, money_add_control} from "./turbo27_end_ctrl";
import {anim_freesin_show, anim_freespin_hide, anim_win_line, anim_winx2} from "./turbo27_anims";
import {STATES} from "../framework/src/states/states";
import AddResult from "../framework/src/connect/result/AddResult";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {set_result_lock} from "./turbo27_core_printer";

var result_control_pos = 0;
var result_fullplate = false;

var spin_win = 0;

export function result_control()
{
    if(inmoneyadd || inbigwin)
    {
        setTimeout(result_control, 100); //waiting for animation end
        return;
    }

    spin_win = 0;
    set_inanim(1);

    result_fullplate = false;

    result_control_pos = 0;
    result_control_part();
}

function result_control_next_part()
{
    result_control_pos++;
    result_control_part();
}

// kontrola vyhry na aktualni pozici
async function result_control_part()
{
    var lw = server_result['result']['lineWins'];

    //console.log(lw == null || lw[result_control_pos] == null);

    if(lw == null || lw[result_control_pos] == null) {

        madnes_win_anim_reset();

        if(in_free_spins) {
            control_freespins();
            //setTimeout(, 100);
        }
        else
        {
            money_add_control();
        }

        if(lw != null)
        {
            set_inwincount(false);
        }
    } else if(get_full_line_win_index() > -1 && !result_fullplate) {

        result_fullplate = true;

        anim_winx2().then(function() {
            result_control_part();
            //result_control_next_part();
        });

    } else {

        states.setState(STATES.SKIP);

        // madnes_hide_stop();

        if(lw[result_control_pos]['type'] == 'freeSpins') {
            madnes_win_anim_reset();
        }

        if(madnes_win_anim_skip()) {

            //if(
            //	server_result.result.lineWins[result_control_pos]['type'] == "wild" ||
            //	server_result.result.lineWins[result_control_pos]['type'] == "normal"
            //) {
            if(typeof lw[result_control_pos]['win'] != "undefined" && lw[result_control_pos]['type'] != "full") {

                let win_set = lw[result_control_pos];

                await madnes_add_win(win_set['win'] * 1);
                spin_win += win_set['win'] * 1;
            }

            if(lw[result_control_pos]['type'] == "full") {
                await madnes_set_win(lw[result_control_pos]['win'] * 1);
                // win = lw['win'];
            }

            /*if(server_result.result.lineWins[result_control_pos]['type'] == "full") {
                spin_win = win = server_result.result.totalWin;
            }*/

            result_control_pos++;
            result_control_part();
            //} else {
            //	result_control_part_proc(server_result.result.lineWins[result_control_pos]);
            //}
        } else {
            //var fli = get_full_line_win_index();
            result_control_part_proc(lw[result_control_pos]);
        }
    }
}

function get_full_line_win_index()
{
    for(var lineI in server_result['result']['lineWins']) {
        if(typeof server_result['result']['lineWins'][lineI] != 'undefined' && server_result['result']['lineWins'][lineI]['type'] == "full") {
            return lineI;
        }
    }

    return -1;
}

let fsCurrent = 0;
export let fsTotal = 0;
let fsAdd = 0;
function result_control_part_proc(win_set)
{
    set_inwincount(true);

    if(win_set['type'] == "freeSpin")
    {
        madnes_start_freespins();

        fsCurrent = freespins.getFreeSpinNumber();
        freespins.run(new AddResult(server_result));
        fsTotal = freespins.getFreeSpinNumber();
        fsAdd = 0;

        result_control_win_add(win_set, 1);

        set_inwincount(false);

        var fsSkipping = freespins.isSkipping();

        if(!in_free_spins)
        {
            // var cname = "lfspos_" + server_config.session_id;

            set_in_free_spins(true);

            // var cookieFsIdx = madnes_get_cookie(cname);
            // if(cookieFsIdx) {
            //     fsSkipping = true;
            //
            //     in_free_spins_pos = cookieFsIdx * 1 + 1;
            //
            //     var fsResult = server_result;
            //     fsResult = server_result['result']['freeSpinResults'][cookieFsIdx];
            //
            //     in_free_spins_total = fsResult['result']['freeSpinNumber'];
            //
            //     if(typeof fsResult['result']['win'] !== 'undefined') {
            //         win = fsResult['result']['win'];
            //     }
            //
            //     spin_win = 0;
            //     if(typeof fsResult['result']['lineWins'] !== 'undefined') {
            //         for(var i = 0; i < fsResult['result']['lineWins'].length; i++) {
            //             if(typeof fsResult['result']['lineWins'][i]['win'] !== 'undefined') {
            //                 spin_win += fsResult['result']['lineWins'][i]['win'];
            //             }
            //         }
            //     }
            // }

            anim_freesin_show(win_set, fsSkipping);

            setTimeout(function() {
                madnes_audio_play('FS_START');
            }, 200);
        }
        else
        {
            if((fsAdd + fsCurrent) != fsTotal /*in_free_spins_total * 1 != server_result['result']['freeSpinNumber'] * 1*/)
            {
                anim_add_fs(400).then(control_freespins);
                return;
            }

            setTimeout(control_freespins, 500);
        }
    }
    else if(win_set['type'] == "multiplier")
    {
        madnes_audio_play("scatter_x2");

        var posY = 2 - win_set['position'];
        var spriteName = "reels_bufer_" + 1 + "_S" + posY;

        madnes_set_texture(spriteName, "symbol_Bonus_r_anim_json");
        madnes_anim_add(spriteName, "anim", madnes_generate_frame_names("symbol_r_x2_", 0, 30, "", 5));
        madnes_anim_add_oncomplete(spriteName, function() {
            setTimeout(function() {

                result_control_win_add(win_set, 1);
                setTimeout(function() {
                    result_control_next_part();
                }, 500);

            }, 1000);
        });

        madnes_anim_play(spriteName, "anim");
    }
    else if(typeof win_set['line'] != "undefined" && win_set['line'] != null && win_set['line'] >= 0)
    {
        madnes_audio_play("win_line_" + picture_convert[win_set['symbol']]);

        result_control_win_add(win_set, result_fullplate ? 2 : 1);
        // madnes_win_anim_add();

        anim_win_line(win_set).then(function() {
            setTimeout(function() {
                result_control_next_part();
            }, 500);
        });

    } /*else if(win_set['type'] == 'full') {

		console.log('fullplate');

		//result_control_win_add(win_set);
		//win += server_result.result.totalWin;
		//spin_win = win;

		anim_winx2().then(function() {
			result_control_next_part();
		});

	}*/ else {
        result_control_next_part();
    }
}

/**
 * @param {number=} delay
 * @returns {Promise}
 */
export function anim_add_fs(delay)
{
    delay = typeof delay === undefined ? 0 : delay;

    return new Promise(function(resolve) {

        if(!in_free_spins) {

            set_in_free_spins(true);
            // in_free_spins_pos = 0;

            madnes_set_text("freespins_text", "0/0");
        }

        madnes_set_visible("freespins_text", true);

        setTimeout(function() {
            anim_add_fs_count().then(function() {
                resolve();
            });
        }, delay);
    });
}

var anim_add_fs_count_resolve = null;
function anim_add_fs_count()
{
    return new Promise(async function(resolve) {

        if((fsAdd + fsCurrent) == fsTotal /*in_free_spins_total*1 === server_result.result.freeSpinNumber*1*/) {
            anim_add_fs_count_resolve = null;

            resolve();
            return;
        }

        anim_add_fs_count_loop();

        anim_add_fs_count_resolve = resolve;
    });
}

function anim_add_fs_count_loop()
{
    if((fsAdd + fsCurrent) != fsTotal /*in_free_spins_total * 1 !== server_result.result.freeSpinNumber * 1*/) {

        fsAdd++;
        // in_free_spins_total++;

        madnes_set_text("freespins_text", freespins.getRoundNumber() + "/" + (fsCurrent + fsAdd));
        madnes_audio_play("bonus_count");
        setTimeout(anim_add_fs_count_loop, 220);

    } else {

        if(anim_add_fs_count_resolve !== null) {
            anim_add_fs_count_resolve();
        }
    }
}

export function set_symbol_center(symbName)
{
    madnes_set_img_center(symbName, 0.5, 0.5);
    madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) + madnes_get_dimension_wi(symbName) / 2);
    madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) + madnes_get_dimension_he(symbName) / 2);
}

export function set_symbol_center_top_left(symbName)
{
    madnes_set_img_center(symbName, 0, 0);
    madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) - madnes_get_dimension_wi(symbName) / 2);
    madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) - madnes_get_dimension_he(symbName) / 2);
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

export var osc_reels = false;
export function set_osc_reels(bool) {
    osc_reels = bool;
}


/**
 * @param {boolean=} fsSkipping
 */
export async function control_freespins(fsSkipping)
{
    var fsResults = server_result['result']['freeSpinResults'];

    var fs_win = spin_win;
    let pos = freespins.getRoundIndex() + 1;

    if(fsResults[pos] == null || typeof fsResults[pos] == "undefined")
    {
        madnes_end_freespins();

        result_fullplate = false;

        madnes_audio_stop('FS_BG');

        set_in_free_spins(false); //in_free_spins = false;
        // in_free_spins_pos = 0;
        // in_free_spins_total = 0;

        anim_freespin_hide();
        ctrl_end_round_freespins();

        spin_win = 0;

    } else {

        let oscReels = false;
        let server_result_tmp = JSON.parse(JSON.stringify(server_result));

        set_result_lock(1);

        if(pos == 0 || fs_win > 0) {
            oscReels = true;
        }

        set_osc_reels(oscReels);
        set_rotated(0);
        set_round_running(0);

        let num = freespins.getFreeSpinNumber();

        await madnes_end_round();

        setTimeout(() => {

            set_server_result(server_result_tmp);

            server_result.result.reelMatrix = fsResults[pos].result.reelMatrix;

            server_result['result']['freeSpinNumber'] = fsResults[pos]['result']['freeSpinNumber'];
            server_result['result']['lineWins'] = fsResults[pos]['result']['lineWins'];
            server_result['result']['gameSpecifics'] = fsResults[pos]['result']['gameSpecifics'];

            set_result_lock(0);

        }, oscReels ? 4000 : 500);

        madnes_set_text("freespins_text", (pos + 1) + "/" + num);

        spin_win = 0;
    }
}

export function get_symbols_from_winset(win_set)
{
    var symbols = [];

    for(var pos in win_set['position']) {
        var xPos = win_set['position'][pos][0];
        var yPos = win_set['position'][pos][1];
        var yPosS = 2 - yPos;

        var symbolIndex = server_result.result.reelMatrix[0][xPos][yPos];
        var symbObj = {
            'spriteName': "reels_bufer_" + xPos + "_S" + yPosS,
            'x': xPos,
            'y': yPosS,
            'isJoker': (get_symbol_name(symbolIndex) == "symbol_Joker")
        };

        symbols.push(symbObj);
    }

    return symbols;
}

export function get_jokers_from_symbols(symbols)
{
    var jokers = [];

    for(var i = 0; i < symbols.length; i++) {
        if(symbols[i]['isJoker']) {
            jokers.push(symbols[i]);
        }
    }

    return jokers;
}

function result_control_win_add(win_set, multiplier)
{
    if(!multiplier)
    {
        multiplier = 1;
    }

    madnes_add_win(win_set['win'] * multiplier);
    spin_win += win_set['win'] * multiplier;
}

function is_center_win_line(winset)
{
    return (winset['line'] == 13);
}

function get_symbol_on_position(x, y)
{
    var sNum = server_result.result.reelMatrix[0][x][y];
    return picture_convert[sNum];
}

function show_all_lines()
{
    for(var i = 0; i <= 26; i++) {
        madnes_set_alpha('winline_' + i, 1);
        madnes_set_visible('winline_' + i, true);
    }
}

export function hide_all_lines()
{
    for(var i = 0; i <= 26; i++) {
        madnes_set_visible('winline_' + i, false);
    }
}

export function fadeout_all_lines()
{
    for(var i = 0; i <= 26; i++) {

        if(madnes_get_visible("winline_" + i) && madnes_get_alpha("winline_" + i) > 0) {
            (function(i) {
                madnes_fade_out("winline_" + i, 400, 0, function() {
                    madnes_set_visible("winline_" + i, false);
                });
            } (i));
        }
    }
}

export function fadeout_all_27()
{
    for(var i = 0; i <= 2; i++) {

        if(madnes_get_visible("win27_left_" + i) && madnes_get_alpha("win27_left_" + i) > 0) {
            (function(i) {
                madnes_fade_out("win27_left_" + i, 400, 0, function() {
                    madnes_set_visible("win27_left_" + i, false);
                });
            } (i));
        }

        if(madnes_get_visible("win27_right_" + i) && madnes_get_alpha("win27_right_" + i) > 0) {
            (function(i) {
                madnes_fade_out("win27_right_" + i, 400, 0, function() {
                    madnes_set_visible("win27_right_" + i, false);
                });
            } (i));
        }

    }
}

export function show_winline(i)
{
    switch(i) {
        case 0: case 3: case 6:
            madnes_set_visible("ring_left_win_2", true);
            madnes_set_visible("ring_right_win_2", true);

            madnes_set_visible("win27_left_2", true);
            madnes_set_visible("win27_right_2", true);
            break;
        case 1: case 4: case 7:
            madnes_set_visible("ring_left_win_2", true);
            madnes_set_visible("ring_right_win_1", true);

            madnes_set_visible("win27_left_2", true);
            madnes_set_visible("win27_right_1", true);

            break;
        case 2: case 5: case 8:
            madnes_set_visible("ring_left_win_2", true);
            madnes_set_visible("ring_right_win_0", true);

            madnes_set_visible("win27_left_2", true);
            madnes_set_visible("win27_right_0", true);

            break;
        case 9: case 12: case 15:
            madnes_set_visible("ring_left_win_1", true);
            madnes_set_visible("ring_right_win_2", true);

            madnes_set_visible("win27_left_1", true);
            madnes_set_visible("win27_right_2", true);

            break;
        case 10: case 13: case 16:
            madnes_set_visible("ring_left_win_1", true);
            madnes_set_visible("ring_right_win_1", true);

            madnes_set_visible("win27_left_1", true);
            madnes_set_visible("win27_right_1", true);

            break;
        case 11: case 14: case 17:
            madnes_set_visible("ring_left_win_1", true);
            madnes_set_visible("ring_right_win_0", true);

            madnes_set_visible("win27_left_1", true);
            madnes_set_visible("win27_right_0", true);

            break;
        case 18: case 21: case 24:
            madnes_set_visible("ring_left_win_0", true);
            madnes_set_visible("ring_right_win_2", true);

            madnes_set_visible("win27_left_0", true);
            madnes_set_visible("win27_right_2", true);

            break;
        case 19: case 22: case 25:
            madnes_set_visible("ring_left_win_0", true);
            madnes_set_visible("ring_right_win_1", true);

            madnes_set_visible("win27_left_0", true);
            madnes_set_visible("win27_right_1", true);

            break;
        case 20: case 23: case 26:
            madnes_set_visible("ring_left_win_0", true);
            madnes_set_visible("ring_right_win_0", true);

            madnes_set_visible("win27_left_0", true);
            madnes_set_visible("win27_right_0", true);

            break;
    }

    madnes_set_visible('winline_' + i, true);
}

export function hide_winline(i) {
    madnes_set_visible('winline_' + i, false);
}

export function hide_all_winline_rings() {
    for(var i = 0; i < 3; i++) {
        madnes_set_visible("ring_left_win_" + i, false);
        madnes_set_visible("ring_right_win_" + i, false);
    }

    hide_all_27();
}

function betmenu_open() {
    show_all_27();
    show_all_lines();
}

export function get_symbol_name(i)
{
    return picture_convert[i];
}

export function get_orig_sprite_name(symbolName)
{
    return madnes_get_texture(symbolName).replace("_blur", "");
}